export default [
    {
        id: 1,
        category: '',
        subtitle: '10/10 THUR 10:35-10:50',
        title: '静音乐队（古典）',
        artist: '弦乐：胡芮熙，钢琴：杨洋',
        detail: [
            { img: 'sche_pic1.jpg' },
            { p: '什么是“静音乐队”？来到主舞台前、戴上耳机，与艺术家们近距离感受这场沉浸式的音乐体验。<br /><br />钢琴：DGC1 ENST PWH<br />静音弦乐器：YSV-104RD' }
        ],
        link: ''
    },
    {
        id: 2,
        category: '',
        subtitle: '10/10 THUR 11:30-11:45',
        title: '静音乐队（管乐）',
        artist: '上海音乐学院铜管五重奏',
        detail: [
            { img: 'sche_pic2.jpg' },
            { p: '什么是“静音乐队”？来到主舞台前、戴上耳机，与艺术家们近距离感受这场沉浸式的音乐体验。<br/>上海音乐学院铜管五重奏由上海音乐学院小号演奏者宋晓玮、邹屹杰，长号演奏者张子阳，大号演奏者周诗颖和圆号演奏者范嘉悦组成。<br /><br />小号：YTR-9335CHS、YTR-9335NYS<br />圆号：YHR-671D<br />长号：YSL-8820R<br />大号：YBB-321' }
        ],
        link: ''
    },
    {
        id: 3,
        category: '',
        subtitle: '10/10 THUR 12:00-12:15',
        title: '双排键独奏',
        artist: '中野正英',
        detail: [
            { img: 'sche_pic6.jpg' },
            { p: '来自日本的艺术家 中野正英 先生 将使用双排键演奏，借助高品质的采样音色，带来层次丰富的音乐体验。<br /><br />ELC-02双排键' }
        ],
        link: ''
    },
    {
        id: 4,
        category: '',
        subtitle: '10/10 THUR 12:40-12:55',
        title: '人工智能伴奏演示',
        artist: '吴晓 青年钢琴演奏家',
        detail: [
            { img: 'sche_pic4.jpg' },
            { p: '结合雅马哈自动演奏钢琴与全新人工智能伴奏技术，实现默契的“人机合奏”。自动演奏钢琴将伴随艺术家演奏时的节奏、力度调整，带来前所未见的二重奏。<br /><br />雅马哈DCFX ENPRO<br />贝森朵夫280VC DISKLAVIER EDITION' }
        ],
        link: ''
    },
    {
        id: 5,
        category: '',
        subtitle: '10/10 THUR 13:30-13:45',
        title: '无人乐队 自动演奏技术体验',
        artist: '雅马哈Real Sound  Viewing自动演奏技术',
        detail: [
            { img: 'sche_pic5.jpg' },
            { p: '钢琴、爵士鼓、低音提琴，都能“自动演奏”？<br/>来自日本的无人演奏技术中国首秀。跟随这支看不见的无人乐队感受科技与音乐的融合。<br /><br />跨界钢琴 DC7X ENPRO<br />架子鼓 Absolute Hybrid Maple<br />雅马哈低音提琴（未引进销售）' }
        ],
        link: ''
    },
    {
        id: 6,
        category: '',
        subtitle: '10/10 THUR 14:00-14:15',
        title: '静音乐队（摇滚）',
        artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
        detail: [
            { img: 'sche_pic3.jpg' },
            { p: '什么是“静音乐队”？来到主舞台前、戴上耳机，与艺术家们近距离感受这场沉浸式的音乐体验。<br/>ASTERISM团名意为“星群”，吉他手HAL-CA、贝斯手MIYU、鼓手MIO因“同样的年纪，同样的品味”组成了这支年轻的乐队。<br/>凭借超强的演奏技巧，以及对重型音乐的热情，迸发出极具感染力的现场表演。成为乐界炙手可热的新兴力量。<br /><br />吉他手 PACIFICA CUSTOM/REVSTAR CUSTOM<br />贝斯手 TRBJP2/ATTITUDE LTD3<br />鼓手 DTX582K' }
        ],
        link: ''
    },
    {
        id: 7,
        category: '',
        subtitle: '10/10 THUR 14:30-14:45',
        title: '电子键盘演示',
        artist: '岛田由羽希',
        detail: [
            { img: 'sche_pic7.png' },
            { p: '来自日本的艺术家  岛田由羽希 小姐，将使用PSR-SX系列最新款带来精彩演奏。这款旗舰级数码音乐工作站，将给你的创作与表演带来强劲助力。<br /><br />PSR-SX900数码与音乐工作站' }
        ],
        link: ''
    },
    {
        id: 8,
        category: '',
        subtitle: '10/10 THUR 15:20-15:35',
        title: 'ASTERISM乐队 演出',
        artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
        detail: [
            { img: 'sche_pic3.jpg' },
            { p: 'ASTERISM团名意为“星群”，吉他手HAL-CA、贝斯手MIYU、鼓手MIO因“同样的年纪，同样的品味”组成了这支年轻的乐队。<br/>凭借超强的演奏技巧，以及对重型音乐的热情，迸发出极具感染力的现场表演。成为乐界炙手可热的新兴力量。<br /><br />吉他手 PACIFICA CUSTOM/REVSTAR CUSTOM<br />贝斯手 TRBJP2/ATTITUDE LTD3<br />鼓手 DTX582K' }
        ],
        link: ''
    },
    {
        id: 9,
        category: '',
        subtitle: '10/10 THUR 16:00-16:15',
        title: '人工智能伴奏演示',
        artist: '吴晓 青年钢琴演奏家',
        detail: [
            { img: 'sche_pic4.jpg' },
            { p: '结合雅马哈自动演奏钢琴与全新人工智能伴奏技术，实现默契的“人机合奏”。自动演奏钢琴将伴随艺术家演奏时的节奏、力度调整，带来前所未见的二重奏。<br /><br />雅马哈DCFX ENPRO<br />贝森朵夫280VC DISKLAVIER EDITION' }
        ],
        link: ''
    },
    {
        id: 10,
        category: '',
        subtitle: '10/11 FRI 10:35-10:50',
        title: '静音乐队（古典）',
        artist: '弦乐：胡芮熙，钢琴：杨洋',
        detail: [
            { img: 'sche_pic1.jpg' },
            { p: '什么是“静音乐队”？来到主舞台前、戴上耳机，与艺术家们近距离感受这场沉浸式的音乐体验。<br /><br />钢琴：DGC1 ENST PWH<br />静音弦乐器：YSV-104RD' }
        ],
        link: ''
    },
    {
        id: 11,
        category: '',
        subtitle: '10/11 FRI 11:30-11:45',
        title: '静音乐队（管乐）',
        artist: '上海音乐学院铜管五重奏',
        detail: [
            { img: 'sche_pic2.jpg' },
            { p: '什么是“静音乐队”？来到主舞台前、戴上耳机，与艺术家们近距离感受这场沉浸式的音乐体验。<br/>上海音乐学院铜管五重奏由上海音乐学院小号演奏者宋晓玮、邹屹杰，长号演奏者张子阳，大号演奏者周诗颖和圆号演奏者范嘉悦组成。<br /><br />小号：YTR-9335CHS、YTR-9335NYS<br />圆号：YHR-671D<br />长号：YSL-8820R<br />大号：YBB-321' }
        ],
        link: ''
    },
    {
        id: 12,
        category: '',
        subtitle: '10/11 FRI 12:00-12:15',
        title: '无人乐队 自动演奏技术体验',
        artist: '雅马哈Real Sound  Viewing自动演奏技术',
        detail: [
            { img: 'sche_pic5.jpg' },
            { p: '钢琴、爵士鼓、低音提琴，都能“自动演奏”？<br/>来自日本的无人演奏技术中国首秀。跟随这支看不见的无人乐队感受科技与音乐的融合。<br /><br />跨界钢琴 DC7X ENPRO<br />架子鼓 Absolute Hybrid Maple<br />雅马哈低音提琴（未引进销售）' }
        ],
        link: ''
    },
    {
        id: 13,
        category: '',
        subtitle: '10/11 FRI 12:40-12:55',
        title: 'ASTERISM乐队 演出',
        artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
        detail: [
            { img: 'sche_pic3.jpg' },
            { p: 'ASTERISM团名意为“星群”，吉他手HAL-CA、贝斯手MIYU、鼓手MIO因“同样的年纪，同样的品味”组成了这支年轻的乐队。<br/>凭借超强的演奏技巧，以及对重型音乐的热情，迸发出极具感染力的现场表演。成为乐界炙手可热的新兴力量。<br /><br />吉他手 PACIFICA CUSTOM/REVSTAR CUSTOM<br />贝斯手 TRBJP2/ATTITUDE LTD3<br />鼓手 DTX582K' }
        ],
        link: ''
    },
    {
        id: 14,
        category: '',
        subtitle: '10/11 FRI 13:30-13:45',
        title: '双排键独奏',
        artist: '中野正英',
        detail: [
            { img: 'sche_pic6.jpg' },
            { p: '来自日本的艺术家 中野正英 先生 将使用双排键演奏，借助高品质的采样音色，带来层次丰富的音乐体验。<br /><br />ELC-02双排键' }
        ],
        link: ''
    },
    {
        id: 15,
        category: '',
        subtitle: '10/11 FRI 14:00-14:15',
        title: '静音乐队（摇滚）',
        artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
        detail: [
            { img: 'sche_pic3.jpg' },
            { p: '什么是“静音乐队”？来到主舞台前、戴上耳机，与艺术家们近距离感受这场沉浸式的音乐体验。<br/>ASTERISM团名意为“星群”，吉他手HAL-CA、贝斯手MIYU、鼓手MIO因“同样的年纪，同样的品味”组成了这支年轻的乐队。<br/>凭借超强的演奏技巧，以及对重型音乐的热情，迸发出极具感染力的现场表演。成为乐界炙手可热的新兴力量。<br /><br />吉他手 PACIFICA CUSTOM/REVSTAR CUSTOM<br />贝斯手 TRBJP2/ATTITUDE LTD3<br />鼓手 DTX582K' }
        ],
        link: ''
    },
    {
        id: 16,
        category: '',
        subtitle: '10/11 FRI 14:30-14:45',
        title: '人工智能伴奏演示',
        artist: '吴晓 青年钢琴演奏家',
        detail: [
            { img: 'sche_pic4.jpg' },
            { p: '结合雅马哈自动演奏钢琴与全新人工智能伴奏技术，实现默契的“人机合奏”。自动演奏钢琴将伴随艺术家演奏时的节奏、力度调整，带来前所未见的二重奏。<br /><br />雅马哈DCFX ENPRO<br />贝森朵夫280VC DISKLAVIER EDITION' }
        ],
        link: ''
    },
    {
        id: 17,
        category: '',
        subtitle: '10/11 FRI 15:20-15:35',
        title: '无人乐队 自动演奏技术体验',
        artist: '雅马哈Real Sound  Viewing自动演奏技术',
        detail: [
            { img: 'sche_pic5.jpg' },
            { p: '钢琴、爵士鼓、低音提琴，都能“自动演奏”？<br/>来自日本的无人演奏技术中国首秀。跟随这支看不见的无人乐队感受科技与音乐的融合。<br /><br />跨界钢琴 DC7X ENPRO<br />架子鼓 Absolute Hybrid Maple<br />雅马哈低音提琴（未引进销售）' }
        ],
        link: ''
    },
    {
        id: 18,
        category: '',
        subtitle: '10/11 FRI 16:00-16:15',
        title: 'ASTERISM乐队 演出',
        artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
        detail: [
            { img: 'sche_pic3.jpg' },
            { p: 'ASTERISM团名意为“星群”，吉他手HAL-CA、贝斯手MIYU、鼓手MIO因“同样的年纪，同样的品味”组成了这支年轻的乐队。<br/>凭借超强的演奏技巧，以及对重型音乐的热情，迸发出极具感染力的现场表演。成为乐界炙手可热的新兴力量。<br /><br />吉他手 PACIFICA CUSTOM/REVSTAR CUSTOM<br />贝斯手 TRBJP2/ATTITUDE LTD3<br />鼓手 DTX582K' }
        ],
        link: ''
    },
    {
        id: 19,
        category: '',
        subtitle: '10/12 SAT 10:10-10:25',
        title: '电钢琴演示',
        artist: '岛田由羽希',
        detail: [
            { img: 'sche_pic7.png' },
            { p: '来自日本的艺术家  岛田由羽希 小姐将使用Clavinova系列最新款的旗舰级电钢琴带来精彩演奏。融合三角钢琴般的体验与丰富真实的音色，到现场感受更富有乐趣的音乐享受。<br /><br />CVP-809GP电钢琴' }
        ],
        link: ''
    },
    {
        id: 20,
        category: '',
        subtitle: '10/12 SAT 10:35-10:50',
        title: '静音乐队（古典）',
        artist: '弦乐：胡芮熙，钢琴：杨洋',
        detail: [
            { img: 'sche_pic1.jpg' },
            { p: '什么是“静音乐队”？来到主舞台前、戴上耳机，与艺术家们近距离感受这场沉浸式的音乐体验。<br /><br />钢琴：DGC1 ENST PWH<br />静音弦乐器：YSV-104RD' }
        ],
        link: ''
    },
    {
        id: 21,
        category: '',
        subtitle: '10/12 SAT 11:00-11:15',
        title: '人工智能伴奏演示',
        artist: '吴晓 青年钢琴演奏家',
        detail: [
            { img: 'sche_pic4.jpg' },
            { p: '结合雅马哈自动演奏钢琴与全新人工智能伴奏技术，实现默契的“人机合奏”。自动演奏钢琴将伴随艺术家演奏时的节奏、力度调整，带来前所未见的二重奏。<br /><br />雅马哈DCFX ENPRO<br />贝森朵夫280VC DISKLAVIER EDITION' }
        ],
        link: ''
    },
    {
        id: 22,
        category: '',
        subtitle: '10/12 SAT 11:30-11:45',
        title: '静音乐队（管乐）',
        artist: '上海音乐学院铜管五重奏',
        detail: [
            { img: 'sche_pic2.jpg' },
            { p: '什么是“静音乐队”？来到主舞台前、戴上耳机，与艺术家们近距离感受这场沉浸式的音乐体验。<br/>上海音乐学院铜管五重奏由上海音乐学院小号演奏者宋晓玮、邹屹杰，长号演奏者张子阳，大号演奏者周诗颖和圆号演奏者范嘉悦组成。<br /><br />小号：YTR-9335CHS、YTR-9335NYS<br />圆号：YHR-671D<br />长号：YSL-8820R<br />大号：YBB-321' }
        ],
        link: ''
    },
    {
        id: 23,
        category: '',
        subtitle: '10/12 SAT 12:00-12:15',
        title: 'ASTERISM乐队 演出',
        artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
        detail: [
            { img: 'sche_pic3.jpg' },
            { p: 'ASTERISM团名意为“星群”，吉他手HAL-CA、贝斯手MIYU、鼓手MIO因“同样的年纪，同样的品味”组成了这支年轻的乐队。<br/>凭借超强的演奏技巧，以及对重型音乐的热情，迸发出极具感染力的现场表演。成为乐界炙手可热的新兴力量。<br /><br />吉他手 PACIFICA CUSTOM/REVSTAR CUSTOM<br />贝斯手 TRBJP2/ATTITUDE LTD3<br />鼓手 DTX582K' }
        ],
        link: ''
    },
    {
        id: 24,
        category: '',
        subtitle: '10/12 SAT 12:40-12:55',
        title: '无人乐队 自动演奏技术体验',
        artist: '雅马哈Real Sound  Viewing自动演奏技术',
        detail: [
            { img: 'sche_pic5.jpg' },
            { p: '钢琴、爵士鼓、低音提琴，都能“自动演奏”？<br/>来自日本的无人演奏技术中国首秀。跟随这支看不见的无人乐队感受科技与音乐的融合。<br /><br />跨界钢琴 DC7X ENPRO<br />架子鼓 Absolute Hybrid Maple<br />雅马哈低音提琴（未引进销售）' }
        ],
        link: ''
    },
    {
        id: 25,
        category: '',
        subtitle: '10/12 SAT 13:30-13:45',
        title: '电子键盘演示',
        artist: '岛田由羽希',
        detail: [
            { img: 'sche_pic7.png' },
            { p: '来自日本的艺术家  岛田由羽希 小姐，将使用PSR-SX系列最新款带来精彩演奏。这款旗舰级数码音乐工作站，将给你的创作与表演带来强劲助力。<br /><br />PSR-SX900数码与音乐工作站' }
        ],
        link: ''
    },
    {
        id: 26,
        category: '',
        subtitle: '10/12 SAT 14:00-14:15',
        title: '静音乐队（古典）',
        artist: '弦乐：胡芮熙，钢琴：杨洋',
        detail: [
            { img: 'sche_pic1.jpg' },
            { p: '什么是“静音乐队”？来到主舞台前、戴上耳机，与艺术家们近距离感受这场沉浸式的音乐体验。<br /><br />钢琴：DGC1 ENST PWH<br />静音弦乐器：YSV-104RD' }
        ],
        link: ''
    },
    {
        id: 27,
        category: '',
        subtitle: '10/12 SAT 14:30-14:45',
        title: '人工智能伴奏演示',
        artist: '吴晓 青年钢琴演奏家',
        detail: [
            { img: 'sche_pic4.jpg' },
            { p: '结合雅马哈自动演奏钢琴与全新人工智能伴奏技术，实现默契的“人机合奏”。自动演奏钢琴将伴随艺术家演奏时的节奏、力度调整，带来前所未见的二重奏。<br /><br />雅马哈DCFX ENPRO<br />贝森朵夫280VC DISKLAVIER EDITION' }
        ],
        link: ''
    },
    {
        id: 28,
        category: '',
        subtitle: '10/12 SAT 15:20-15:35',
        title: '无人乐队 自动演奏技术体验',
        artist: '雅马哈Real Sound  Viewing自动演奏技术',
        detail: [
            { img: 'sche_pic5.jpg' },
            { p: '钢琴、爵士鼓、低音提琴，都能“自动演奏”？<br/>来自日本的无人演奏技术中国首秀。跟随这支看不见的无人乐队感受科技与音乐的融合。<br /><br />跨界钢琴 DC7X ENPRO<br />架子鼓 Absolute Hybrid Maple<br />雅马哈低音提琴（未引进销售）' }
        ],
        link: ''
    },
    {
        id: 29,
        category: '',
        subtitle: '10/12 SAT 16:00-16:15',
        title: 'ASTERISM乐队 演出',
        artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
        detail: [
            { img: 'sche_pic3.jpg' },
            { p: 'ASTERISM团名意为“星群”，吉他手HAL-CA、贝斯手MIYU、鼓手MIO因“同样的年纪，同样的品味”组成了这支年轻的乐队。<br/>凭借超强的演奏技巧，以及对重型音乐的热情，迸发出极具感染力的现场表演。成为乐界炙手可热的新兴力量。<br /><br />吉他手 PACIFICA CUSTOM/REVSTAR CUSTOM<br />贝斯手 TRBJP2/ATTITUDE LTD3<br />鼓手 DTX582K' }
        ],
        link: ''
    },
    {
        id: 30,
        category: '',
        subtitle: '10/13 SUN 10:10-10:25',
        title: 'ASTERISM乐队 演出',
        artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
        detail: [
            { img: 'sche_pic3.jpg' },
            { p: 'ASTERISM团名意为“星群”，吉他手HAL-CA、贝斯手MIYU、鼓手MIO因“同样的年纪，同样的品味”组成了这支年轻的乐队。<br/>凭借超强的演奏技巧，以及对重型音乐的热情，迸发出极具感染力的现场表演。成为乐界炙手可热的新兴力量。<br /><br />吉他手 PACIFICA CUSTOM/REVSTAR CUSTOM<br />贝斯手 TRBJP2/ATTITUDE LTD3<br />鼓手 DTX582K' }
        ],
        link: ''
    },
    {
        id: 31,
        category: '',
        subtitle: '10/13 SUN 10:35-10:50',
        title: '静音乐队（摇滚）',
        artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
        detail: [
            { img: 'sche_pic3.jpg' },
            { p: '什么是“静音乐队”？来到主舞台前、戴上耳机，与艺术家们近距离感受这场沉浸式的音乐体验。<br/>ASTERISM团名意为“星群”，吉他手HAL-CA、贝斯手MIYU、鼓手MIO因“同样的年纪，同样的品味”组成了这支年轻的乐队。<br/>凭借超强的演奏技巧，以及对重型音乐的热情，迸发出极具感染力的现场表演。成为乐界炙手可热的新兴力量。<br /><br />吉他手 PACIFICA CUSTOM/REVSTAR CUSTOM<br />贝斯手 TRBJP2/ATTITUDE LTD3<br />鼓手 DTX582K' }
        ],
        link: ''
    },
    {
        id: 32,
        category: '',
        subtitle: '10/13 SUN 11:00-11:15',
        title: '无人乐队 自动演奏技术体验',
        artist: '雅马哈Real Sound  Viewing自动演奏技术',
        detail: [
            { img: 'sche_pic5.jpg' },
            { p: '钢琴、爵士鼓、低音提琴，都能“自动演奏”？<br/>来自日本的无人演奏技术中国首秀。跟随这支看不见的无人乐队感受科技与音乐的融合。<br /><br />跨界钢琴 DC7X ENPRO<br />架子鼓 Absolute Hybrid Maple<br />雅马哈低音提琴（未引进销售）' }
        ],
        link: ''
    },
    {
        id: 33,
        category: '',
        subtitle: '10/13 SUN 11:30-11:45',
        title: '静音乐队（管乐）',
        artist: '上海音乐学院铜管五重奏',
        detail: [
            { img: 'sche_pic2.jpg' },
            { p: '什么是“静音乐队”？来到主舞台前、戴上耳机，与艺术家们近距离感受这场沉浸式的音乐体验。<br/>上海音乐学院铜管五重奏由上海音乐学院小号演奏者宋晓玮、邹屹杰，长号演奏者张子阳，大号演奏者周诗颖和圆号演奏者范嘉悦组成。<br /><br />小号：YTR-9335CHS、YTR-9335NYS<br />圆号：YHR-671D<br />长号：YSL-8820R<br />大号：YBB-321' }
        ],
        link: ''
    },
    {
        id: 34,
        category: '',
        subtitle: '10/13 SUN 12:00-12:15',
        title: '电钢琴演示',
        artist: '岛田由羽希',
        detail: [
            { img: 'sche_pic7.png' },
            { p: '来自日本的艺术家  岛田由羽希 小姐将使用Clavinova系列最新款的旗舰级电钢琴带来精彩演奏。融合三角钢琴般的体验与丰富真实的音色，到现场感受更富有乐趣的音乐享受。<br /><br />CVP-809GP电钢琴' }
        ],
        link: ''
    },
    {
        id: 35,
        category: '',
        subtitle: '10/13 SUN 12:40-12:55',
        title: '人工智能伴奏演示',
        artist: '吴晓 青年钢琴演奏家',
        detail: [
            { img: 'sche_pic4.jpg' },
            { p: '结合雅马哈自动演奏钢琴与全新人工智能伴奏技术，实现默契的“人机合奏”。自动演奏钢琴将伴随艺术家演奏时的节奏、力度调整，带来前所未见的二重奏。<br /><br />雅马哈DCFX ENPRO<br />贝森朵夫280VC DISKLAVIER EDITION' }
        ],
        link: ''
    },







]